import { render, staticRenderFns } from "./auxiliaryFacility.vue?vue&type=template&id=631cd9f0&scoped=true&"
import script from "./auxiliaryFacility.vue?vue&type=script&lang=js&"
export * from "./auxiliaryFacility.vue?vue&type=script&lang=js&"
import style0 from "./auxiliaryFacility.vue?vue&type=style&index=0&id=631cd9f0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631cd9f0",
  null
  
)

export default component.exports